<template>
    <v-row>
        <v-col>
            まだなにもなし
        </v-col>
    </v-row>
</template>